import {useFormik} from "formik";
import * as Yup from "yup";
import {persianToEnglish} from "../../tools/helpers";
import React, {useContext, useState} from "react";
import Button from "../Button";
import Api from "../../tools/service";
import ProgressLoading from "../loading/ProgressLoading";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../modals/ErrorModal";
import DatePicker from "../DatePicker";
import {AuthenticationDefaultSteps} from "../../tools/defaults/authentication/Authentication";
import {PiUserListLight} from "react-icons/pi";
import Switch from "react-switch";
import UserAuthenticationContext from "../../tools/contexts/authenticatonService/UserAuthenticationContext";
import REQUEST_URLS from "../../tools/defaults/requestUrl";
const InitConfirm = () => {
    const userAuthenticationContext=useContext(UserAuthenticationContext);
    const [checkSwitch,setCheckSwitch]=useState(false)
    const [loading, setLoading] = useState(false);
    const defaultInputs = {
        NationalId: {
            label: 'کد ملی',
            placeholder: 'کد ملی را وارد کنید'
        },
        BirthDate: {
            label: 'تاریخ تولد',
            placeholder: 'تاریخ تولد را وارد کنید'
        }
    }
    const handleSubmit = (values) => {

        setLoading(true);
        const data={
            pid: userAuthenticationContext.pid,
            ...(userAuthenticationContext.process?.init_confirm_inputs.includes('NationalId')  && {
                NationalId: persianToEnglish(values.NationalId),
            }),
            ...(userAuthenticationContext.process?.init_confirm_inputs.includes('BirthDate') && {
                BirthDate: values.BirthDate,
            }),
        };


        Api.put(REQUEST_URLS.DIVAR_INTERNAL_AUTH.INIT_CONFIRM,data , {
            headers: {
                "Authorization": `Bearer ${userAuthenticationContext.token}`
            }
        }).then((response => {
            const {data, status, message, hasError} = response;
            if (hasError) {
                setLoading(false)
                userAuthenticationContext.handleError({
                    status,
                    message,
                    data,
                    pid: userAuthenticationContext.pid,
                    callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای سرویس',
                            onConfirm: () => {

                            },
                            confirmButtonText: '',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'بستن',
                            cancelButtonTheme: 'red',
                            onCancel: () => {
                                Reoverlay.hideModal();

                            }
                        })
                    }
                })
            } else {
                userAuthenticationContext.handleGetProcess(userAuthenticationContext.pid);
            }
        })).catch(e => {

        })

    }
    const buildValidationSchema = (validationFields) => {

        let schema = Yup.object();

        if (validationFields.includes('NationalId') && userAuthenticationContext.process?.reseted_step !== AuthenticationDefaultSteps.BUSINESS_LICENSE_INQUIRY) {
            schema = schema.shape({
                NationalId: Yup.string()
                    .min(10, 'کد ملی عددی ۱۰ رقمی می باشد.')
                    .max(10, 'کد ملی عددی ۱۰ رقمی می باشد.')
                    .required('  کد ملی را وارد کنید.')
                    .test("isNumber", " کد ملی عددی می باشد", (value) => {
                        if (!value) {
                            return false;
                        }
                        return !isNaN(persianToEnglish(value));
                    }),
            });
        }

        if (validationFields.includes('BirthDate')) {
            schema = schema.shape({
                BirthDate: Yup.string().required('تاریخ تولد را وارد کنید.'),
            });
        }

        // Add other fields to the schema similarly if needed

        return schema;
    };
    const ValidationSchema = buildValidationSchema(userAuthenticationContext.process?.init_confirm_inputs)
    const formik = useFormik({
        initialValues: {
            ...(userAuthenticationContext.process?.init_confirm_inputs.includes('NationalId') && userAuthenticationContext.process?.reseted_step !== AuthenticationDefaultSteps.BUSINESS_LICENSE_INQUIRY && {
                NationalId: userAuthenticationContext.process?.national_id||''
            }),
            ...(userAuthenticationContext.process?.init_confirm_inputs.includes('BirthDate') && {
                BirthDate: ''
            })

        },
        validationSchema: ValidationSchema,
        onSubmit: handleSubmit,
    });
    if (loading) {
        return <ProgressLoading showProgress={false} type="NIDCardReader" duration={30} text="در حال دریافت اطلاعات "
                                theme="green"/>
    }
    return <div className="flex mt-10 flex-col items-center  justify-center">

        <div className="w-11/12 lg:w-4/12 mx-auto bg-white mt-5   p-5 rounded-lg ">
            <div className="border-b flex flex-col items-center  my-3 pb-5 ">
                <div className="w-16 h-16 mb-2  bg-green-100 flex justify-center items-center rounded-full">
                    <PiUserListLight className="text-3xl text-green-800" />
                </div>
                <h1 className="mb-1 font-bold text-lg ">تکمیل اطلاعات </h1>
            </div>
            <label className="text-sm mb-3 "
                   >تلفن همراه</label>
            <input disabled className="w-full mt-1    bg-green-900 opacity-50  text-white  text-right rounded-xl p-3"
                   type="tel"
                   id="mobile"
                   name="mobile"
                   placeholder="تلفن همراه"
                   value={userAuthenticationContext.process.platform_user}
            />
            <form onSubmit={formik.handleSubmit}>
                {userAuthenticationContext.process?.init_confirm_inputs.map((fieldName) => (
                    <div className="flex flex-col mt-2 " key={fieldName}>

                        {fieldName === 'NationalId' &&(!userAuthenticationContext.process?.reseted_step|| (userAuthenticationContext.process?.reseted_step  && userAuthenticationContext.process?.reseted_step !==AuthenticationDefaultSteps.AUTO_NID_CARD)) && (
                            <>
                                <label className="text-sm mb-3 "
                                       htmlFor={fieldName}>{defaultInputs[fieldName].label} <span className="text-red-600">*</span></label>
                                <input className="w-full mt-1  bg-gray-100  text-right rounded-xl p-3"
                                       type="tel"
                                       id={fieldName}
                                       name={fieldName}
                                       placeholder={defaultInputs[fieldName].placeholder}
                                       onChange={formik.handleChange}
                                       onBlur={formik.handleBlur}
                                       value={formik.values[fieldName]}
                                />
                            </>
                        )}

                        {fieldName === 'BirthDate' && (
                            <>
                                <label className="text-sm mb-2 mt-4 "
                                       htmlFor={fieldName}>{defaultInputs[fieldName].label} <span className="text-red-600">*</span></label>
                                <DatePicker onError={value=>formik.setFieldValue('BirthDate',value)} initialDate={userAuthenticationContext.process.birth_date} onComplete={(value)=>{formik.setFieldValue('BirthDate',value)}} />
                            </>


                        )}

                        {formik.touched[fieldName] && formik.errors[fieldName] && (
                            <p className="text-red-400 text-sm font-light mt-1">{formik.errors[fieldName]}</p>
                        )}
                    </div>
                ))}
                <div className="flex justify-between my-10 ">
                    <label  className="text-sm" htmlFor="insurance">از مطابقت شماره موبایل ، کدملی، تاریخ تولد اطمینان دارم.</label>
                    <Switch onColor="#36b570" onChange={(checked)=>{
                        setCheckSwitch(checked)

                    }} dir="rtl" size={50} checkedIcon={false} uncheckedIcon={false} height={20} width={40}  checked={checkSwitch} />
                </div>
                <Button disabled={!checkSwitch} className="text-sm mt-3 w-full rounded-lg " theme="green" type={"submit"}>ادامه</Button>
            </form>
        </div>
    </div>
}

export default InitConfirm;